// extracted by mini-css-extract-plugin
module.exports = {"privacy-container":"privacy_privacy-container__1Gyfj","spinner":"privacy_spinner__hpffg"};